import { combineReducers } from 'redux';
import authReducer from './authReducer';
import othersReducer from './othersReducer';
import userReducer from './userReducer';
import userServletReducer from './userServletReducer';
import guidelineReducer from './guidelineReducer';

export default combineReducers({
  authReducer,
  othersReducer,
  userReducer,
  userServletReducer,
  guidelineReducer,
});
